<template>
  <oie-layout-grid
    ref="productListPageWrapper"
    :class="['product-list-page-wrapper', { 'grid--list': useListView, 'grid--grid': !useListView, 'element--is-loading element--is-loading--at-top': loading }]"
    css-classes="grid--four">
    <template v-for="(product,i) in products">
      <oie-product-shell
        :key="`product-loop-${i}`"
        :class="[{ 'product-shell--show-variants': isExpanded(product.id) }, { 'product-shell--showing-technical-information': isTechnicalInformationBlockActive(product.id) }]">
        <oie-product-card
          :product="product"
          :index="i"
          :type-of-listing="typeOfListing"></oie-product-card>

        <oie-product-technical-information v-if="(useListView || mq('to-small') ) && Object.keys(product.specification).length > 0" slot="technical-information" :product-id="product.id">
          <div class="grid grid--four techinical-facts__grid">
            <template v-for="(technicalSpec, categoryName) in product.specification">
              <div :key="categoryName" class="property-container">
                <div class="property-container__header">
                  {{ categoryName }}
                </div>

                <table class="property-table technical-facts__table">
                  <tr v-for="(value, key) in technicalSpec" :key="key" class="property-table__item">
                    <td>
                      {{ key }}
                    </td>

                    <td>
                      {{ value }}
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </div>
        </oie-product-technical-information>

        <!-- fractions search page -->
        <oie-product-fraction-wrapper v-if="product.fractions && product.fractions.length > 0">
          <template #list>
            <li v-for="fraction in product.fractions" :key="fraction" :class="['product-fits__list-item']">
              {{ fraction }}
            </li>
          </template>
        </oie-product-fraction-wrapper>
      </oie-product-shell>

      <oie-product-variant-shell
        v-show="isExpanded(product.id)"
        :key="`product-loop-${i}--variants`"
        :index="i"
        :title="product.name"
        :card-id="product.id">
        <template v-slot:default="slotProps">
          <oie-product-variants
            :apply-article-number-shadow="slotProps.applyArticleNumberShadow"
            :apply-stock-price-shadow="slotProps.applyStockPriceShadow"
            :product="product"
            :type-of-listing="typeOfListing"
            :is-search-page="true"></oie-product-variants>
        </template>

        <template v-if="expandMoreArticlesInSearch(product)" v-slot:expand-all>
          <button class="variant-shell__toggle-all" @click="displayAllVariantRows(product.id)">
            {{ tStatic('showMatchingArticles').replace('{0}', product.items.filter(i => !i.selected).length) }}
          </button>
        </template>
      </oie-product-variant-shell>
    </template>

    <template v-for="filler of 3">
      <div :key="`filler-${filler}`" class="grid__item--filler"></div>
    </template>
  </oie-layout-grid>
</template>

<script>
// TODO: Refactor this component to NOT be tied to search page but also reusable on node pages and other places where we list products
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    useListView: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      default: () => []
    },
    typeOfListing: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    productExpanded: null,
    madeReset: false
  }),
  computed: {
    ...mapGetters('ui', ['showTechnicalnformation', 'useVat', 'isTechnicalInformationBlockActive']),
    ...mapGetters('productVariants', ['isExpanded', 'displayAllVariants'])
  },
  watch: {
    products(value) {
      this.publish('product-list-page-wrapper.products-updated', value)
    },
    useListView(newVal) {
      this.toggleShowAllVariants(false)
      this.publish('toggle.articles.all', false)
      if (!newVal) {
        this.$nextTick(function () {
          this.resetElementHeightBundle()
          this.setElementHeightsBundle()
        })
      } else {
        this.resetElementHeightBundle()
      }
    }
  },
  async mounted() {
    this.subscribe('product.wrapper.element.eq', () => {
      requestAnimationFrame(() => {
        this.resetElementHeightBundle()
        this.setElementHeightsBundle()
      })
    })

    _.forEach(['resize', 'orientationchange'], event => {
      window.addEventListener(event, _.throttle(() => {
        if (!this.useListViewComputed && this.mq('small')) {
          this.setElementHeightsBundle()

          this.madeReset = false
        } else {
          if (!this.madeReset) {
            this.resetElementHeightBundle()

            this.madeReset = true
          }
        }
      }, 400))
    })
  },
  methods: {
    ...mapActions('productVariants', ['displayAllVariantRows', 'toggleShowAllVariants']),
    setElementHeight (selector, timeout = false) {
      const wrapper = this.$refs['productListPageWrapper']
      const grid = Array.from(wrapper.$el.children)

      const baseOffset = grid[0].offsetTop
      const breakIndex = grid.findIndex(item => item.offsetTop > baseOffset)
      const numPerRow = (breakIndex === -1 ? grid.length : breakIndex)
      const element = wrapper.$el.querySelectorAll(selector)

      setTimeout(() => {
        for (let i = 0; i < element.length; i = i + numPerRow) {
          let height = 0

          for (let j = i; j < i + numPerRow; j++) {
            if (j < element.length) {
              let cardHeight = element[j].scrollHeight

              if (selector === '.product-card') {
                cardHeight = cardHeight + 2
              }

              if (cardHeight > height) {
                height = cardHeight
              }
            }
          }

          for (let j = i; j < i + numPerRow; j++) {
            if (j < element.length) {
              element[j].style.height = `${height}px`
            }
          }
        }
      }, timeout ? 400 : 0)
    },
    setElementHeightsBundle() {
      if (!this.useListViewComputed && this.mq('small')) {
        this.setElementHeight('.product-card__name')
        this.setElementHeight('.product-card__descriptions')
        this.setElementHeight('.product-card__article-number')
        this.setElementHeight('.product-card__manufacturer-logo')
        this.setElementHeight('.product-card__actions', true)
      }
    },
    resetElementHeight (selector) {
      _.forEach(document.querySelectorAll(selector), (element) => {
        element.style.height = ''
      })
    },
    resetElementHeightBundle() {
      this.resetElementHeight('.product-card')
      this.resetElementHeight('.product-card__name')
      this.resetElementHeight('.product-card__descriptions')
      this.resetElementHeight('.product-card__article-number')
      this.resetElementHeight('.product-card__actions')
    },
    expandMoreArticlesInSearch(product) {
      const totalItemsCount = product.items.length
      const isSelectedCount = product.items.filter(item => item.selected).length
      return (isSelectedCount < totalItemsCount) && !this.displayAllVariants(product.id)
    }
  }
}
</script>

<style lang="scss">
.product-list-page-wrapper {
  position: relative;
  min-height: 7rem;
}
</style>
